import store from "app/store/store";

export const getSportIdFromName = (sportName: string): number | null => {
  const { navigationTree } = store.getState().navigationModel;
  if (!navigationTree?.length) {
    console.warn("Navigation data not yet loaded");
    return null;
  }
  for (const sport of navigationTree[0].nodes) {
    // sportname is url friendly, ie with hyphens, so need to convert the sportname from
    // the navigation tree in the same format to compare
    if (toUrlFriendlyName(sport.translatedName) === sportName.toLowerCase()) {
      return sport.id;
    }
  }
  return null;
};

export const getCompetitionIdFromName = (
  competitionName: string
): number | null => {
  const { navigationTree } = store.getState().navigationModel;
  if (!navigationTree?.length) {
    console.warn("Navigation data not yet loaded");
    return null;
  }

  // Search through all sports and countries for the competition
  for (const sport of navigationTree[0].nodes) {
    for (const country of sport.nodes) {
      // competition name is url friendly, ie with hyphens, so need to convert the competition name from
      // the navigation tree in the same format to compare
      const competition = country.nodes.find(
        competition => toUrlFriendlyName(competition.name) === competitionName
      );
      if (competition) {
        return competition.id;
      }
    }
  }
  return null;
};

export const getCountryIdFromNameAndSportId = (
  countryName: string,
  sportId: number
): string | null => {
  const { navigationTree } = store.getState().navigationModel;
  for (const sport of navigationTree[0].nodes) {
    if (sport.id !== sportId) {
      continue;
    }
    for (const country of sport.nodes) {
      // country name is url friendly, ie with hyphens, so need to convert the country name from
      // the navigation tree in the same format to compare
      if (
        toUrlFriendlyName(country.translatedName) === countryName.toLowerCase()
      ) {
        return country.id;
      }
    }
  }
  return null;
};

// Convert name to URL-friendly format
export const toUrlFriendlyName = (name: string): string => {
  return name.replace(/\s+/g, "-").toLowerCase();
};
